import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet';
import Error from '../components/ui/Error';
import Loader from '../components/ui/Loader';
import Navbar from '../components/ui/Navbar'
import { useGetAssignmentMarksQuery } from '../features/assignmentMarks/assignmentMarksApi'
import { useGetQuizzMarksQuery } from '../features/quizzMarks/quizzMarksApi';
import useAuth from '../hooks/useAuth';

function LeaderBoard() {
	//variables
	const { data: assignmentmarks, isLoading: isAssignmentLoading, isSuccess: isAssignmentSuccess, isError: isAssignmentError } = useGetAssignmentMarksQuery();
	const { data: quizzMarks, isLoading: isQuizLoading, isSuccess: isQuizSuccess, isError: isQuizError } = useGetQuizzMarksQuery();
	const { id: student_id } = useAuth();

	//States
	const [topStudents, setTopStudents] = useState([]);
	const [myInfo, setMyInfo] = useState({});


	//Hooks
	useEffect(() => {
		if (isQuizSuccess && !isQuizLoading && isAssignmentSuccess && !isAssignmentLoading) {
			// Count total marks for each student for quiz and assignment
			const totalMarks = {};

			assignmentmarks?.forEach(a => {
				if (!totalMarks[a.student_id]) {
					totalMarks[a.student_id] = {
						name: a.student_name,
						id: a.student_id,
						quiz: 0,
						assignment: 0
					};
				}
				totalMarks[a.student_id].assignment += a.mark;
			});

			quizzMarks?.forEach(q => {
				if (!totalMarks[q.student_id]) {
					totalMarks[q.student_id] = {
						name: q.student_name,
						id: q.student_id,
						quiz: 0,
						assignment: 0
					};
				}
				totalMarks[q.student_id].quiz += q.mark;
			});

			// Sort students by total marks
			const topStudents = Object.values(totalMarks)
				.sort((a, b) => (b.quiz + b.assignment) - (a.quiz + a.assignment))

			let rank = 0;
			topStudents.forEach((s, index) => {
				const prevStudent = topStudents[index - 1];
				const currentStudent = topStudents[index];
				if ((prevStudent && (prevStudent.quiz + prevStudent.assignment)) !== (currentStudent && (currentStudent.quiz + currentStudent.assignment))) {
					rank += 1;
				}
				s['rank'] = rank;

				if (s.id === student_id) {
					setMyInfo({ ...s });
				}
			});
			setTopStudents(topStudents);
		}

	}, [assignmentmarks, quizzMarks, student_id, isQuizLoading, isQuizSuccess, isAssignmentLoading, isAssignmentSuccess]);

	const { rank, name, quiz, assignment } = myInfo || {};

	//Decide what to render
	let content = null;

	if (isQuizLoading || isAssignmentLoading) {
		content = <Loader />
	}
	if ((!isQuizLoading || !isAssignmentLoading) && (isQuizError || isAssignmentError)) {
		content = <Error message="There was an error occured!" />
	}
	if ((!isQuizLoading || !isAssignmentLoading) && (!isQuizError || !isAssignmentError) && (assignmentmarks?.length === 0 && quizzMarks?.length === 0)) {
		content = <div className='text-center'>No Marks Found!</div>
	}

	if ((!isQuizLoading || !isAssignmentLoading) && (!isQuizError || !isAssignmentError) && (assignmentmarks?.length > 0 || quizzMarks?.length > 0)) {
		content = (<section className="py-6 bg-primary">
			<div className="mx-auto max-w-7xl px-5 lg:px-0">
				{rank &&
					<div>
						<h3 className="text-lg font-bold">Your Position in Leaderboard</h3>
						<table className="text-base w-full border border-slate-600/50 rounded-md my-4">
							<thead>
								<tr>
									<th className="table-th !text-center">Rank</th>
									<th className="table-th !text-center">Name</th>
									<th className="table-th !text-center">Quiz Mark</th>
									<th className="table-th !text-center">Assignment Mark</th>
									<th className="table-th !text-center">Total</th>
								</tr>
							</thead>

							<tbody>
								<tr className="border-2 border-cyan">
									<td className="table-td text-center font-bold">{rank}</td>
									<td className="table-td text-center font-bold">{name}</td>
									<td className="table-td text-center font-bold">{quiz}</td>
									<td className="table-td text-center font-bold">{assignment}</td>
									<td className="table-td text-center font-bold">{quiz + assignment}</td>
								</tr>
							</tbody>
						</table>
					</div>
				}
				<div className="my-8">
					<h3 className="text-lg font-bold">Top 20 Result</h3>
					<table className="text-base w-full border border-slate-600/50 rounded-md my-4">
						<thead>
							<tr className="border-b border-slate-600/50">
								<th className="table-th !text-center">Rank</th>
								<th className="table-th !text-center">Name</th>
								<th className="table-th !text-center">Quiz Mark</th>
								<th className="table-th !text-center">Assignment Mark</th>
								<th className="table-th !text-center">Total</th>
							</tr>
						</thead>

						<tbody>
							{topStudents?.length > 0 && topStudents.map((student, index) => {
								const { name, assignment, quiz, rank } = student;
								if (rank > 20) return null;
								return (
									<tr className="border-b border-slate-600/50" key={index}>
										<td className="table-td text-center">{rank}</td>
										<td className="table-td text-center">{name}</td>
										<td className="table-td text-center">{quiz}</td>
										<td className="table-td text-center">{assignment}</td>
										<td className="table-td text-center">{assignment + quiz}</td>
									</tr>
								)
							})}
						</tbody>
					</table>
				</div>
			</div>
		</section>)
	}

	return (
		<>
			<Helmet>
				<title>LeaderBoard</title>
			</Helmet>
			<Navbar />
			{content}
		</>
	)
}

export default LeaderBoard